module.exports = __webpack_public_path__ + "static/media/crisis-situations.7497d660.png";